import script from "./OpinionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OpinionPanel.vue?vue&type=script&setup=true&lang=js"

import "./OpinionPanel.vue?vue&type=style&index=0&id=bb5bf37e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb5bf37e"]])

export default __exports__